<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="540px">
      <v-card>
        <v-card-title class="InsertTitle">
          <v-toolbar color="primary" dark>既読状況</v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-form ref="p1DialogForm" v-model="valid" lazy-validation>
            <v-container>
              <v-row>
                <ryou-table
                  ref="ryouTablePop"
                  :rowKey="rowKey"
                  :title="'既読状況一覧'"
                  :headers="headers"
                  :url="popUrl"
                  :showSelect="false"
                  :singleSelect="false"
                  :businessKey="businessKey"
                  :autoLoad="false"
                  :dummy="false"
                  class="InsertTitle1"
                >
                </ryou-table>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <ryou-black-btn
            :label="'閉じる'"
            :handlerClick="handleCancel"
            :iconCls="'mdi-close'"
          >
          </ryou-black-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import RyouTable from "@/components/table/RyouTable.vue";
import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";

import { RyouTableMixins } from "@/mixins/RyouTableMixins";

export default {
  mixins: [RyouTableMixins],
  components: {
    RyouBlackBtn,
    RyouTable,
  },
  mounted() {
    this.inputRules.push(this.GlobalRules.required);
  },
  props: {
    url: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data: () => ({
    dialog: false,
    title: "",
    valid: true,
    inputRules: [],
    rowKey: "rowIndex",
    businessKey: "info_seq_no",
    popUrl: {
      originlist: "/noticeRegistration/noticeInformationReadGet/",
      list: "/noticeRegistration/noticeInformationReadGet/",
    },
    tableName: "ryouTablePop",
    headers: [
      {
        text: "社員番号",
        value: "user_id",
        width: "140",
        sortable: true,
        groupable: false,
      },
      {
        text: "氏名",
        value: "user_name",
        width: "170",
        sortable: false,
        groupable: false,
      },
      {
        text: "既読状況",
        value: "read_name",
        width: "130",
        sortable: false,
        groupable: false,
      },
    ],
  }),
  methods: {
    edit(value) {
      this.open(value);
      this.title = "既読状況";
      setTimeout(() => {
        this.model = Object.assign({}, value);
      }, 10);
    },
    handleCancel() {
      this.close();
    },
    close() {
      this.dialog = false;
    },
    open(value) {
      this.dialog = true;

      var that = this;
      setTimeout(() => {
        //that.$refs.ryouTablePop.$on(
        //   "getSelectedRowKeys",
        //   this.getSelectedRowKeys
        // );
        // // ポップアップ画面でグリッド検索のURLを変更します
        // that.$refs.ryouTablePop.url.list += localStorage.getItem("info_seq_no");

        that.$refs.ryouTablePop.url.list = that.popUrl.originlist + value;
        // localStorage.removeItem("info_seq_no");
        // ポップアップ画面でグリッド検索処理を行う
        that.$refs.ryouTablePop.loadData();
      }, 10);

      if (this.$refs.p1DialogForm) {
        this.$refs.p1DialogForm.reset();
        this.$refs.p1DialogForm.resetValidation();
      }
    },
  },
};
</script>

<style scoped>
.InsertTitle {
  padding: 0px 0px 12px !important;
}
.InsertTitle1 {
  padding: 5px 0px 0px 0px;
}
</style>